import { render, staticRenderFns } from "./ForfatterInfo.vue?vue&type=template&id=1bdae668&"
import script from "./ForfatterInfo.vue?vue&type=script&lang=js&"
export * from "./ForfatterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1bdae668', component.options)
    } else {
      api.reload('1bdae668', component.options)
    }
    module.hot.accept("./ForfatterInfo.vue?vue&type=template&id=1bdae668&", function () {
      api.rerender('1bdae668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/lf_forfatter/ForfatterInfo.vue"
export default component.exports